export const UserInfoFormatterService = Symbol.for('UserInfoFormatterService');
